module.exports = __webpack_public_path__ + "img/Group44499.c75792af.svg";